import axios from "../../../util/axios";

export default {
    /** 查询公告列表 */
    queryProclamationList: (data) => axios.get({url: "/basedata/system/message/queryProclamationList", data}),
    /** 查询预警消息列表 */
    queryWarnList: (data) => axios.get({url: "/basedata/system/message/queryWarnList", data}),

    /** 保存草稿 */
    saveDraft: (data) => axios.post({url: "/basedata/system/message/saveDraft", data}),
    /** 发布 */
    savePublish: (data) => axios.post({url: "/basedata/system/message/savePublish", data}),
    /** 删除 */
    delete: (id) => axios.del({url: "/basedata/system/message/delete", data: {id}}),
    /** 删除预警消息 */
    deleteWarn: (id) => axios.del({url: "/basedata/system/message/deleteWarn", data: {id}}),
    /** 撤销 */
    revoke: (id) => axios.del({url: "/basedata/system/message/revoke", data: {id}}),
    /** 查询详情 */
    findById: (id) => axios.get({url: "/basedata/system/message/findById", data: {id}}),
}